import Vue from 'vue'
import Vuetify from 'vuetify/lib'
// import '@/theme/app.styl'

Vue.use(Vuetify)

export default new Vuetify({
  icons: {
    iconfont: 'mdi'
  }
})
